import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";

export const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Close menu on navigation change
  const handleNavLinkClick = () => {
    setIsMenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".navbar")) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick);
    }

    return () => document.removeEventListener("click", handleOutsideClick);
  }, [isMenuOpen]);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          <NavLink to="/" className="navbar-brand page-scroll" onClick={handleNavLinkClick}>
            <img
              src="/img/icon.png"
              alt="Technosun Enterprises Logo"
              style={{ height: "30px", marginRight: "10px", display: "inline-block" }}
            />
            TECHNOSUN ENTERPRISES
          </NavLink>
        </div>

        <div className={`navbar-collapse ${isMenuOpen ? "in" : "collapse"}`} id="bs-navbar">
          <ul className="nav navbar-nav navbar-right">
            <li>
              <NavLink to="/" className="page-scroll" exact activeClassName="active" onClick={handleNavLinkClick}>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" className="page-scroll" activeClassName="active" onClick={handleNavLinkClick}>
                About
              </NavLink>
            </li>
            <li>
              <NavLink to="/services" className="page-scroll" activeClassName="active" onClick={handleNavLinkClick}>
                Services
              </NavLink>
            </li>
            <li>
              <NavLink to="/portfolio" className="page-scroll" activeClassName="active" onClick={handleNavLinkClick}>
                Portfolio
              </NavLink>
            </li>
            <li>
              <NavLink to="/blog" className="page-scroll" activeClassName="active" onClick={handleNavLinkClick}>
                Blog
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className="page-scroll" activeClassName="active" onClick={handleNavLinkClick}>
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
